import PropTypes from "prop-types";
import React, { Component } from "react";
import { Helmet } from 'react-helmet'

class PageHelmet extends Component {
    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{this.props.pageTitle} - พิพิธภัณฑ์สิงห์ท่ายโสธร</title>
                    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
                    <meta property="og:image" content="/assets/images/logo/logo.webp" />
                    <meta name="description" content="นิทรรศการหมุนเวียน เรื่องเล่าเมืองสิงห์ท่า ร่วมค้นหาความหมายของคำว่า สิงห์ท่า และตำนานสิงห์คู่" />
                    <meta name="keywords" content="ฟาร์มสเตย์, พิพิธภัณฑ์สิงห์ท่า, ยโสธร" />
                    <meta name="author" content="singhathamuseum" />
                </Helmet>
            </React.Fragment>
        )
    }
}
PageHelmet.propTypes = {
    title: PropTypes.string
};
export default PageHelmet;
